<template>
  <div class="tab-warpper">
    <div v-for="item in list_data" :key="item.index">
      <el-card class="box-card">
        <div slot="header" class="hd">
          <div class="left_tab">
            <span>患者:</span>
            <span>{{item.patientName }}</span>
          </div>
        </div>
        <div class="content">
          <div class="c_item">
            <span>年龄:</span>
            <span>{{  item.patientAge  }}</span>
          </div>
          <div class="c_item">
            <span> 进度状态:</span>
            <el-tag type="warning" effect="plain">{{
              PRESCRIPTION_STATUS[item.status]
            }}</el-tag>
          </div>
        </div>
        <div class="footer">
          <el-button type="primary" size="mini" @click="detailHandle(item)"
            >查看详情</el-button
          >
        </div>
      </el-card>
    </div>
    <div v-if="list_data.length == 0" class="empty">
      <emptyData />
    </div>
  </div>
</template>

<script>
import util from "@/utils";
import { PRESCRIPTION_STATUS } from "@/utils/constants.js";
import { getOrderList, appointHande, } from "@/api/index.js";
import { getPrescription } from "@/api/doctor";
import emptyData from "@/components/common/emptyData.vue";
export default {
  name: "",
  components: { emptyData },
  props: {},
  data() {
    return {
      list_data: [],
      PRESCRIPTION_STATUS
    };
  },
  created() {
    const that = this;
    that.readyList();
  },
  methods: {
    edit(item, type) {
      let data = {
        status: type,
        id: item.id,
      };
      appointHande(data).then((res) => {
        if (res.code == "1") {
          this.$message({
            message: res.msg,
            type: "success",
          });
          if (type == "-1") {
            return;
          } else {
            this.$router.push({
              path: "/index/work/patients",
            });
          }
          this.readyList();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 详情
    detailHandle(item) {
      let query = {
        id: item.id,
        case_id: item.cases_id,
      };
      this.$router.push({
        path: "/index/user/auditPrescription/prescriptionDetails",
        query,
      });
    },
    /**
     * 获取待审核列表
     */
    async readyList() {
      const params = {
        status: "0",
        pageNo: 1,
        pageSize: 5,
        pharmacistId: '',
      };
      let res = await getPrescription(params);
      if (res.code ==1) this.list_data = res.data.records;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-warpper {
  .hd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .right_tab {
      .right_tab_wait {
        color: #7d7979;
      }
      .right_tab_complete {
        color: #019e4e;
      }
    }
  }
  .content {
    line-height: 25px;
    margin: 5px 0;
    display: block;
    .c_item span {
      margin: 0 5px;
    }
  }

  .footer {
    border-top: 1px solid #ccc;
    padding: 5px 0;
    text-align: right;
  }
}
.empty {
  width: 50%;
  margin: 0 auto;
  margin-top: 50%;
}
</style>
